import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Container, Logo } from '../landing/shared';
import { Footer } from '../landing/Footer';

export const LegalLayout = ({ title, updated, children, testId }) => {
  useEffect(() => { document.title = `${title} | Bican Coskun`; window.scrollTo(0, 0); }, [title]);
  return (
    <div className="min-h-screen overflow-x-hidden bg-paper font-sans text-ink [overflow-wrap:anywhere]" data-testid={testId}>
      <header className="sticky top-0 z-50 border-b border-white/10 bg-paper">
        <Container className="flex h-16 items-center justify-between sm:h-[72px]">
          <Logo />
          <Link to="/" className="inline-flex min-h-[44px] items-center gap-2 rounded-full px-3 text-sm text-ink hover:text-white" data-testid="legal-back-link">
            <ArrowLeft size={16} aria-hidden="true" /> Startseite
          </Link>
        </Container>
      </header>
      <main className="py-14 sm:py-20">
        <Container className="max-w-[820px]">
          <h1 className="font-serif text-3xl font-bold leading-tight text-white [hyphens:auto] sm:text-5xl" lang="de">{title}</h1>
          <div className="legal mt-10 space-y-10 text-[15px] leading-relaxed sm:text-base">{children}</div>
          <p className="mt-12 text-sm text-ink/70">Stand: {updated}</p>
        </Container>
      </main>
      <Footer />
    </div>
  );
};

export const Sec = ({ title, children }) => (
  <section>
    <h2 className="font-display text-xl font-bold text-white sm:text-2xl">{title}</h2>
    <div className="mt-4 space-y-3">{children}</div>
  </section>
);

export const Box = ({ children }) => (
  <div className="rounded-[20px] border border-line bg-navy p-5 sm:p-6">{children}</div>
);

export const ExtLink = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className="text-brand underline underline-offset-2">{children || href}</a>
);
